import { render, staticRenderFns } from "./SelectAdditionalServicesComponent.vue?vue&type=template&id=35ed8dbc&scoped=true"
import script from "./SelectAdditionalServicesComponent.vue?vue&type=script&lang=js"
export * from "./SelectAdditionalServicesComponent.vue?vue&type=script&lang=js"
import style0 from "./SelectAdditionalServicesComponent.vue?vue&type=style&index=0&id=35ed8dbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ed8dbc",
  null
  
)

export default component.exports